import { memo } from 'react';
import { TXCenter } from '@/api/apis/facilities';
import { OpoOrganization } from '@/api/apis/opo';
import { RoleSpecificationSection } from './RoleSpecificationSection';

type ContractorRoleSpecificationSectionProps = {
  isReadOnly?: boolean;
  txCenter?: TXCenter;
  opo?: OpoOrganization;
  onTxCenterSelect: (value?: TXCenter) => void;
  onOpoSelect: (value?: OpoOrganization) => void;
  onAffiliationTypeChange: (value: string) => void;
};

export const ContractorRoleSpecificationSection = memo(
  ({
    isReadOnly,
    txCenter,
    opo,
    onTxCenterSelect,
    onOpoSelect,
    onAffiliationTypeChange,
  }: ContractorRoleSpecificationSectionProps) => {
    return (
      <RoleSpecificationSection
        isReadOnly={isReadOnly}
        txCenter={txCenter}
        opo={opo}
        onTxCenterSelect={onTxCenterSelect}
        onOpoSelect={onOpoSelect}
        onAffiliationTypeChange={onAffiliationTypeChange}
      />
    );
  },
);
